function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ImageTokenHelper = function ImageTokenHelper() {
  var _this = this;

  _defineProperty(this, "setShouldUseImageToken", function () {
    _this.shouldUseImageToken = true;
  });

  _defineProperty(this, "addToken", function (url, item) {
    var token = item.dto.imageToken || item.dto.token;

    if (token) {
      return url + ("?token=" + token);
    }

    return url;
  });

  this.shouldUseImageToken = false;
};

export default new ImageTokenHelper();